// src/components/project/ProjectAccessInfo.js

const ProjectAccessInfo = ({ project, user }) => {
  const hasAccess = project.users?.some(u => u.id === user.id) || user.admin;

  return (
    <div className={`alert alert-${hasAccess ? 'info' : 'warning'} small`}>
      {hasAccess ? 'У вас есть доступ к этому проекту.' : 'У вас нет доступа к этому проекту.'}
    </div>
  );
};

export default ProjectAccessInfo;
